import React from "react"
// import cx from "classnames"
import BandMember from "./band-member"
import michael from "../images/michael-aurora-1.jpg"
import jake from "../images/jake-3.jpg"
import gary from "../images/gary-tripp.jpg"
import stefan from "../images/stefan-3.jpg"

const members = [
  {
    name: "Jake Nist",
    blurb: [
      'Jake’s bass journey began mid-stride during a long run with the Central Washington University Cross Country team. A teammate was switching to guitar, a Fender Precision bass became available, and Jake—having never played a bass and completely unsure of how to even put it on—said yes. A quick trip to Boogie Man Music in Ellensburg secured a tiny practice amp and a how-to book. The book was immediately ditched in favor of playing along to the radio, though the amp is somehow still kicking.  Naturally, jamming with friends led to the inevitable band scene and multiple ultimatums of: "Well, if you’re just standing there playing bass, you might as well sing, too." Jake took the mic and never looked back. He honed his teeth in the Tacoma scene with the bands The Shadow Puppets and Devil on a Leash, and stints as the "backup bassist" for Midnight Salvage Company. Present day, Jake has been holding down the low end and lead vocals for East of Friday since 2017. He brings a rock solid sense of time and a good ear for harmony to every set, proving that all those years of cross-country running were really just cardio training for fronting a rock band.',
    ],
    photo: jake,
    instruments: "Lead Vocals, Bass",
    ref: "jake",
  },
  {
    name: "Michael Kintzer",
    blurb: [
      "Michael has been playing guitar since the early '80's during his college days in Michigan.  He formed his first band, Sanity Check, performing covers and his originals, in Austin, Texas in 1994.  Two of Michael's songs made finalist and semi-finalist categories in the Austin Songwriters Group.  After moving to Seattle in 1996, Michael joined Radio 80, an 80's cover band.",
      "Michael, Jake and Rick Boe formed East of Friday in 2017.  Michael also performs regularly in the Festival of Friends community and has participated in mini tribute sets to The Cult, Social Distortion, The Clash, Oasis, and Tears for Fears.  He also performed with Festival of Friends in 2024 at The Moore Theatre in the Seattle Rocks for Ukraine benefit.",
      "Michael thinks The Clash is The Only Band That Matters and if it's not in a tortilla, it's not worth eating.",
    ],
    instruments: "Lead Guitar, Backing Vocals",
    photo: michael,
    ref: "michael",
  },
  {
    name: "Stefan Perrin",
    blurb: [
      "Stefan has been the East of Friday drummer since early 2018. From his earliest recollections, he has been tapping his fingers to whatever beat came across the radio, recordings or wherever he heard music. His biggest influences are Ringo Starr, John Bonham, Neil Peart and that toy monkey that crashes those tiny cymbals. He has accomplished amazing feats such as getting through an entire set without dropping a drumstick and counting to four. He has even remembered how songs start and where they should end and on occasion, remembered where the breaks are.",
    ],
    photo: stefan,
    instruments: "Drums",
    ref: "stefan",
  },
  {
    name: "Gary Tripp",
    blurb: [
      "Gary has played keyboards and guitar as a solo act, at the Hillside Chapel church in Redmond, WA, with School of Rock, and in various bands in Los Angeles and Seattle. At McCabe’s Guitar Shop in Santa Monica, Gary learned blues guitar from Bernie Pearl, whose mentor was Lightnin’ Hopkins.",
      "Gary joined East of Friday in 2026. Major influences are Roxy Music, The Beatles, The Rolling Stones and David Bowie.",
    ],
    photo: gary,
    instruments: "Keyboards, Rhythm Guitar, Backing Vocals",
    ref: "gary",
  },
]
const Bios = () => (
  <div className="container bios">
    <div className="bios">
      <BandMember members={members} />
    </div>
  </div>
)
export default Bios
